import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./Accordian.scss";
import classNames from "classnames";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { colors } from "Constants/colorConstants";
import AnimateHeight from "UIComponents/AnimateHeight";
import { CaretRightFilled, CaretDownFilled } from "@toddle-edu/ds-icons";
import { Badge } from "@toddle-edu/ds-web";
import { onEnterOrSpaceKeyDown } from "Utils";

class Accordian extends PureComponent {
  state = {
    isExpanded: this.props.isExpanded,
  };

  componentDidUpdate(prevProps) {
    const { isExpanded } = this.props;

    if (prevProps.isExpanded !== isExpanded)
      this.setState({ isExpanded: isExpanded });
  }

  onAccordianClick = e => {
    const { shouldStopPropagation = false } = this.props;
    if (shouldStopPropagation) e?.stopPropagation();
    const { getIsExpanded, isDisabled } = this.props;
    if (isDisabled) return;

    const { isExpanded } = this.state;
    this.setState({ isExpanded: !isExpanded });

    if (getIsExpanded) {
      getIsExpanded(isExpanded);
    }
  };

  handleKeyDownOnAccordian = e => {
    const { isLeftIconContainerFocusable } = this.props;
    if (isLeftIconContainerFocusable)
      onEnterOrSpaceKeyDown(e, this.onAccordianClick);
  };

  render() {
    const {
      props: {
        title,
        readOnly,
        expandedContent,
        testId,
        getExpandedContent,
        showLabelBorder,
        hideContainerBorder,
        count,
        customTitleStyle,
        mainContentContainerStyle,
        mainContainerClass,
        customTitleComponent,
        headerStyle,
        showLeftArrow,
        customLeftIcon,
        isDisabled,
        showCountBadge,
        applyDangerTitleClass,
        leftArrowStyle = {},
        customArrowContainerClass,
        customHeaderClass,
        headerAction,
        customCountStyle,
        customRightArrow,
        isLeftIconContainerFocusable,
        containerStyle,
        dsVersion,
        expandedContainerStyle,
        arrowStyleCustom,
        showHeaderActionsOnExpand,
        showHeaderActionsOnCollapse,
      },
      state: { isExpanded },
    } = this;

    const arrowStyle = classNames(
      { [classes.arrowContainer]: true },
      { [classes.openArrow]: isExpanded },
      { [classes.closeArrow]: !isExpanded }
    );

    const leftArrowClass = classNames(
      { [classes.leftArrowContainer]: true },
      { [classes.leftOpenArrow]: isExpanded },
      { [classes.leftCloseArrow]: !isExpanded }
    );

    const titleStyle = classNames(
      { [classes.headerLabel]: true },
      { [classes.headerLabelOpen]: isExpanded },
      { [classes.customTitleDanger]: applyDangerTitleClass }
    );

    const mainContainer = classNames(
      { [mainContainerClass]: !!mainContainerClass },
      { [classes.mainContainer]: true },
      { [classes.showLabelBorder]: showLabelBorder },
      { [classes.showLabelBorderV2]: showLabelBorder && dsVersion === "2.0" }
    );

    const mainContentContainer = classNames(
      { [classes.mainContentContainer]: true },
      { [classes.hideContainerBorder]: hideContainerBorder }
    );

    const headerContainer = classNames(
      { [classes.headerContainer]: true },
      {
        [customHeaderClass]:
          !_.isNil(customHeaderClass) && !_.isNil(customArrowContainerClass),
      }
    );

    const titleStyleCustom = {
      ...customTitleStyle,
      color: isExpanded ? colors.textDefault : customTitleStyle.color,
    };

    const mainContainerCustomStyle =
      isExpanded && !_.isEmpty(expandedContainerStyle)
        ? expandedContainerStyle
        : containerStyle;

    const showHeaderAction =
      (showHeaderActionsOnExpand && isExpanded) ||
      (showHeaderActionsOnCollapse && !isExpanded);

    return (
      <div className={mainContainer} style={mainContainerCustomStyle}>
        <div
          className={headerContainer}
          style={{
            ...headerStyle,
            justifyContent: showLeftArrow ? "flex-start" : "space-between",
          }}
          data-test-id={`${testId}-accordian`}
          onClick={this.onAccordianClick}
        >
          {showLeftArrow && !isDisabled && (
            <div
              className={leftArrowClass}
              style={leftArrowStyle}
              tabIndex={isLeftIconContainerFocusable ? 0 : -1}
              onKeyDown={this.handleKeyDownOnAccordian}
            >
              {customLeftIcon ? (
                customLeftIcon
              ) : (
                <CaretRightFilled size={"x-small"} />
              )}
            </div>
          )}
          {customTitleComponent ? (
            customTitleComponent
          ) : (
            <div className={classes.titleContainer}>
              <div style={titleStyleCustom} className={titleStyle}>
                {title}
              </div>
              {count > 0 ? (
                showCountBadge ? (
                  <div className={classes.badgeStyle}>
                    <Badge
                      type="numeric"
                      size={"medium"}
                      variant="filter"
                      value={count}
                    />
                  </div>
                ) : (
                  <div className={classes.countStyle} style={customCountStyle}>
                    {count}
                  </div>
                )
              ) : null}
            </div>
          )}
          {!showLeftArrow && !isDisabled ? (
            <ConditionalWrapper
              condition={!_.isNil(customArrowContainerClass)}
              wrapper={<div className={customArrowContainerClass} />}
              type={"wrapperAsElement"}
            >
              <>
                {headerAction && showHeaderAction ? (
                  <div className={classes.headerActionContainer}>
                    {headerAction}
                  </div>
                ) : null}
                <div
                  className={arrowStyle}
                  tabIndex="0"
                  onKeyDown={this.handleKeyDownOnAccordian}
                  style={arrowStyleCustom}
                >
                  {customRightArrow ? customRightArrow : <CaretDownFilled />}
                </div>
              </>
            </ConditionalWrapper>
          ) : null}
        </div>

        <AnimateHeight
          duration={300}
          height={isExpanded || readOnly ? "auto" : 0}
          style={{ width: "100%" }}
        >
          <div
            style={mainContentContainerStyle}
            className={mainContentContainer}
          >
            {getExpandedContent
              ? isExpanded
                ? getExpandedContent()
                : null
              : expandedContent}
          </div>
        </AnimateHeight>
      </div>
    );
  }
}

Accordian.defaultProps = {
  testId: "",
  showLabelBorder: true,
  hideContainerBorder: false,
  count: 0,
  customTitleStyle: {},
  isExpanded: false,
  mainContentContainerStyle: {},
  headerStyle: {},
  showLeftArrow: false,
  customLeftIcon: null,
  isDisabled: false,
  showCountBadge: false,
  applyDangerTitleClass: false,
  isRightArrowChervon: false,
  isLeftIconContainerFocusable: true,
  containerStyle: {},
  expandedContainerStyle: {},
  arrowStyleCustom: {},
  dsVersion: "1.0",
  showHeaderActionsOnExpand: false,
  showHeaderActionsOnCollapse: false,
};

export default Accordian;
